import React from 'react';
import PropTypes from 'prop-types';
import {
  AdditionalSignUpFieldsOption,
  BooleanOption,
  InitialScreenOption,
  LanguageOption,
  ConnectionOption,
  LogoOption,
  ColorOption
} from './';

const EditorOption = ({ name, value, onChange, defaultColor, logos }) => {
  switch (name) {
    case 'additionalSignUpFields':
      return <AdditionalSignUpFieldsOption value={value} onChange={onChange} />;
    case 'allowLogin':
    case 'allowForgotPassword':
    case 'allowSignUp':
    case 'mustAcceptTerms':
      return <BooleanOption name={name} value={value} onChange={onChange} />;
    case 'initialScreen':
      return <InitialScreenOption value={value} onChange={onChange} />;
    case 'language':
      return <LanguageOption value={value} onChange={onChange} />;
    case 'logo':
      return (
        <LogoOption
          value={value}
          logos={logos}
          onChange={onChange}
        />
      );
    case 'primaryColor':
      return (
        <ColorOption
          value={value}
          onChange={onChange}
          defaultColor={defaultColor}
        />
      );
    case 'allowedConnections':
      return <ConnectionOption value={value} onChange={onChange} />;
    default:
      return <span />;
  }
};

EditorOption.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  preset: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  defaultColor: PropTypes.string,
  logos: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired
  }).isRequired)
};

export default EditorOption;



// WEBPACK FOOTER //
// ./src/components/EditorOption/EditorOption.js


// WEBPACK FOOTER //
// webpack:///src/components/EditorOption/EditorOption.js